<div mat-dialog-title class="dialog-header d-flex justify-content-between">
  @if (type === 'Add') {
    <div i18n="@@addDepartment">Add Department</div>
  }
  @if (type !== 'Add') {
    <div i18n="@@editDepartment">Edit Department</div>
  }
  <mat-icon (click)="closeDialog()" class="cursor" i18n-aria-label="@@closeDialogIcon" aria-label="Close">close</mat-icon>
</div>

<mat-dialog-content>
  <form [formGroup]="addDepartmentForm">
    <div class="form-group">
      <mat-form-field class="w-100" appearance="outline">
        <mat-label i18n="@@departmentNameLabel">Department name</mat-label>
        <input data-testid="add_edit_department_input" matInput id="department_name" i18n-placeholder="@@departmentNamePlaceholder" placeholder="Department name" name="department_name" formControlName="department_name" required />
        <mat-error>
          @if (!addDepartmentForm.get('department_name').valid && addDepartmentForm.get('department_name').touched) {
            @if (addDepartmentForm.get('department_name').errors && addDepartmentForm.get('department_name').errors['required'] || addDepartmentForm.get('department_name').hasError('whitespace')) {
              <span i18n="@@inValidRequiredField">This field is required</span>
            }
          }
        </mat-error>
      </mat-form-field>
    </div>
    <div>
      @if (type === 'Add') {
        <button i18n="@@add" data-testid="add_department_button" class="w-100" mat-raised-button color="primary" (click)="onSubmit()">Add</button>
      }
      @if (type !== 'Add') {
        <button i18n="@@save" data-testid="edit_department_button" class="w-100" mat-raised-button color="primary" (click)="onSubmit()">Save</button>
      }
    </div>
  </form>
</mat-dialog-content>